<template>
  <DefaultLayout class="!bg-slate-50">
    <v-row class="mx-5 mt-2 font-inter">
      <v-col cols="12">
        <BreadcrumbComponent
          :items="[
            { label: 'Master Data' },
            { label: 'Renewable Energy', active: true },
          ]"
        />
        <h2 class="font-bold text-2xl text-[#232323] font-inter">
          Master Data - Renewable Energy
        </h2>
      </v-col>
      <v-col cols="12" class="bg-white shadow-md p-3 rounded-md mb-10">
        <div class="flex gap-3">
          <v-btn
            variant="outlined"
            class="capitalize font-medium text-xs w-44 border-2 text-red-600 border-red-600"
          >
            Tipe Renewable Energy
          </v-btn>
        </div>
        <hr class="my-3 border-t-2 border-dashed border-gray-500" />
        <h2 class="text-lg font-medium text-slate-800">
          Tipe Renewable Energy ({{ existing.totalItems }})
        </h2>
        <div class="flex justify-between items-center mt-3" v-if="!isEdit">
          <div class="flex gap-3 items-center w-full">
            <v-text-field
              variant="outlined"
              density="compact"
              hide-details
              clearable
              v-model="keyword"
              @keyup.enter="fetchData"
              @click:clear="fetchData"
              color="#475569"
              prepend-inner-icon="mdi-magnify"
              placeholder="Cari dengan nama"
              class="w-64 max-w-64"
            >
            </v-text-field>
            <v-autocomplete
              variant="outlined"
              hide-details
              color="#475569"
              v-model="active"
              item-title="title"
              item-value="value"
              :items="[
                { title: 'Semua Status', value: '' },
                { title: 'Active', value: true },
                { title: 'Inactive', value: false },
              ]"
              density="compact"
              placeholder="Semua Status"
              class="w-40 max-w-40"
              @update:model-value="fetchData"
            >
            </v-autocomplete>
          </div>
          <v-btn
            class="capitalize text-xs min-w-40 w-40 bg-gray-800"
            @click="getAllData()"
          >
            <span class="text-white text-sm">Tambah/Edit</span>
            <template v-slot:prepend>
              <img
                src="../../../assets/icon/edit.png"
                alt="icon"
                class="w-5 h-auto"
                loading="lazy"
              />
            </template>
          </v-btn>
        </div>
        <div class="flex justify-between items-center mt-3" v-else>
          <v-btn
            class="min-w-40 w-40 border-gray-500 bg-white"
            variant="outlined"
            @click="addRow()"
          >
            <span class="capitalize text-gray-600 text-sm">Tambah Data</span>
            <template v-slot:prepend>
              <img
                src="../../../assets/icon/add-square-white.png"
                alt="icon"
                class="w-5 h-auto"
                loading="lazy"
              />
            </template>
          </v-btn>
          <div class="flex gap-3 items-center justify-end w-full">
            <v-btn
              class="min-w-40 w-40 border-gray-500 bg-white"
              variant="outlined"
              @click="cencelEdit()"
            >
              <span class="capitalize text-gray-600 text-sm">Batal</span>
            </v-btn>
            <v-btn
              variant="text"
              class="min-w-40 w-40 bg-red-600"
              id="btn-submit"
              @click="submitData()"
            >
              <span class="capitalize text-white text-sm font-medium">
                Submit
              </span>
              <img
                src="../../../assets/icon/send.png"
                alt="Submit Icon"
                class="ml-2 h-4 w-auto"
              />
            </v-btn>
          </div>
        </div>
        <v-form ref="formData" class="mt-4">
          <RenewableEnergyTableComponent
            v-model:dataTable="dataTable"
            :existing="existing"
            :form-validasi="formValidasi"
            :isEdit="isEdit"
            :handle-input="handleInput"
            :add-row="addRow"
            :remove-row="removeRow"
            :fetch-data="fetchData"
          />
        </v-form>
      </v-col>
    </v-row>
  </DefaultLayout>
  <ModalDelete
    v-model="dialogDelete"
    @close-modal="closeModal"
    @delete-data="deleteData"
  />
  <ModalValidation
    v-model="dialogValidation"
    :data="errorMessages"
    @close-modal="closeModal"
  />
</template>

<script>
import ModalDelete from "@/components/ModalDelete.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ModalValidation from "../components/ModalValidation.vue";
import { CreateDataTableObject } from "@/utilities/DataTableHelpers";
import {
  FormCreateDataRenewableEnergy,
  FormValidasiDataRenewableEnergy,
} from "./core/FormData";
import util from "@/assets/js/util";
import axios from "axios";
import { cloneDeep } from "lodash";
import { ActionEnum } from "@/utilities/enum";
import { APP_BACKEND_ESG } from "@/constants";
import RenewableEnergyTableComponent from "./components/RenewableEnergyTableComponent.vue";
import { formatNumber } from "@/pages/esg/core/FormData";
import BreadcrumbComponent from "@/components/BreadcrumbComponent.vue";

const base_url = APP_BACKEND_ESG;

export default {
  name: "MasterDataRenewableEnergy",
  components: {
    DefaultLayout,
    ModalDelete,
    ModalValidation,
    RenewableEnergyTableComponent,
    BreadcrumbComponent,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "", align: "start", width: "5%" },
        {
          title: "Nama Renewable Energy",
          key: "name",
          align: "start",
          width: "30%",
        },
        { title: "Status", align: "start", width: "30%" },
        {
          title: "Konversi PLN",
          key: "konversi_pln",
          align: "start",
          width: "30%",
        },
        { title: "", align: "start", width: "5%" },
      ]),
      existing: {
        items: [],
        totalItems: 0,
        perPage: 10,
        page: 1,
        loading: false,
        sortBy: null,
      },
      isEdit: false,
      formValidasi: cloneDeep(FormValidasiDataRenewableEnergy),
      dialogValidation: false,
      dialogDelete: false,
      deleteId: null,
      errorMessages: [],
      keyword: null,
      active: "",
    };
  },
  watch: {
    "dataTable.items": {
      handler(newItems) {
        newItems.forEach((item) => {
          const index = item.existing_index;

          if (index !== undefined && this.existing.items[index]) {
            const newItem = { ...item };
            delete newItem.existing_index;
            this.existing.items.splice(index, 1, newItem);
          }

          const keyMap = new Map();

          this.existing.items
            .filter((data) => {
              return !data.deleted && data.name;
            })
            .forEach((item, index) => {
              let key = item.name.toLowerCase();

              if (!keyMap.has(key)) {
                keyMap.set(key, []);
              }
              keyMap.get(key).push(index);
            });

          this.existing.items
            .filter((data) => {
              return !data.deleted && data.name;
            })
            .forEach((item) => {
              let key = item.name.toLowerCase();

              const duplicateIndexes = keyMap.get(key) || [];
              item.duplicate = duplicateIndexes.length > 1;
            });
        });
      },
      deep: true,
    },
  },
  methods: {
    addRow() {
      const formData = cloneDeep(FormCreateDataRenewableEnergy);
      Object.assign(formData, { uuid: Date.now() + Math.random() });

      this.existing.items.unshift(formData);
      this.existing.totalItems = this.existing.items.filter(
        (item) => !item.deleted,
      ).length;

      this.existing.page = 1;

      const perPage = this.existing.perPage;
      const startIndex = 0;

      this.dataTable.items = this.existing.items
        .map((item, index) => ({ ...item, existing_index: index }))
        .filter((item) => !item.deleted)
        .slice(startIndex, startIndex + perPage);

      this.dataTable.start_index = startIndex;
    },
    removeRow(existing_index) {
      if (this.isEdit) {
        const page = this.existing.page;
        const perPage = this.existing.perPage;
        this.existing.items = this.existing.items.map((item, index) => {
          if (index === existing_index) {
            item.deleted = true;
            item.is_touched = true;
          }
          return item;
        });

        this.existing.totalItems =
          this.existing.items.filter((item) => !item.deleted).length ?? 0;

        this.dataTable.items = this.existing.items
          .map((item, index) => ({ ...item, existing_index: index }))
          .filter((item) => !item.deleted)
          .slice((page - 1) * perPage, page * perPage);
      } else {
        this.deleteId = this.dataTable.items.find(
          (item) => item.existing_index === existing_index,
        ).id;
        this.dialogDelete = true;
      }
    },
    async fetchData({ page, itemsPerPage, sortBy } = {}) {
      if (this.isEdit) {
        this.existing.page = page ?? 1;
        this.existing.perPage = itemsPerPage ?? 10;
        if (sortBy && sortBy[0]) {
          if (sortBy && sortBy[0]) {
            const { key, order } = sortBy[0];
            this.existing.items.sort((a, b) => {
              const valA = (a[key] ?? "").toString().toLowerCase();
              const valB = (b[key] ?? "").toString().toLowerCase();

              if (valA < valB) return order === "asc" ? -1 : 1;
              if (valA > valB) return order === "asc" ? 1 : -1;
              return 0;
            });
          }
        }

        const startIndex = (page - 1) * itemsPerPage;

        this.dataTable.items = this.existing.items
          .map((item, index) => ({ ...item, existing_index: index }))
          .filter((item) => !item.deleted)
          .slice(startIndex, startIndex + itemsPerPage);

        this.dataTable.start_index = startIndex;
      } else {
        try {
          this.existing.loading = true;
          const res = await axios.get(`${base_url}/renewable-energy`, {
            params: {
              name: this.keyword?.trim(),
              active: this.active,
              page: page,
              size: itemsPerPage,
              sortBy: sortBy ? sortBy[0] : null,
            },
          });

          const pageData = res.data.current_page || 1;
          const perPageData = res.data.total_per_page;
          const startIndex = (pageData - 1) * perPageData;

          this.existing.page = pageData;
          this.existing.perPage = perPageData;
          this.existing.totalItems = res.data.total_data;
          this.existing.sortBy = sortBy ? sortBy[0] : null;

          this.dataTable.items = res.data.data.map((item, index) => ({
            ...item,
            name_touched: false,
            existing_index: index,
          }));
          this.dataTable.start_index = startIndex;
        } catch (err) {
          this.existing.loading = false;
          util.showError(err);
        } finally {
          this.existing.loading = false;
        }
      }
    },
    async getAllData() {
      try {
        this.existing.loading = true;
        this.isEdit = true;
        const res = await axios.get(`${base_url}/renewable-energy`, {
          params: {
            name: this.keyword?.trim(),
            active: this.active,
            page: this.existing.page,
            size: -1,
            sortBy: this.existing.sortBy,
          },
        });

        this.existing.items =
          res.data.data.map((item) => ({
            ...item,
            uuid: Date.now() + Math.random(),
            name_touched: false,
            konversi_pln_touched: false,
            deleted: false,
            is_touched: false,
          })) || [];
        this.existing.totalItems = res.data.total_data || 0;

        const page = this.existing.page;
        const perPage = this.existing.perPage;
        const startIndex = (page - 1) * perPage;

        this.dataTable.items = this.existing.items
          .map((item, index) => ({ ...item, existing_index: index }))
          .slice(startIndex, startIndex + perPage);
        this.dataTable.start_index = startIndex;
      } catch (err) {
        this.isEdit = false;
        this.existing.loading = false;
        util.showError(err);
      } finally {
        this.existing.loading = false;
      }
    },
    async submitData() {
      const formData = await this.$refs.formData.validate();
      const items = this.existing.items.filter((item) => !item.deleted);
      const itemsValid = items.every((item) => item.name && item.konversi_pln);

      if (formData.valid && itemsValid) {
        let bodyJson = this.existing.items
          .filter(
            (item) =>
              (item.id || (!item.id && !item.deleted)) && item.is_touched,
          )
          .map((data) => ({
            id: data.id,
            name: data.name,
            konversi_pln: data.konversi_pln,
            active: data.active,
            action: !data.id
              ? ActionEnum.CREATE
              : data.deleted
                ? ActionEnum.DELETE
                : ActionEnum.UPDATE,
          }));
        try {
          const res = await axios.post(
            `${base_url}/renewable-energy`,
            bodyJson,
          );

          util.showInfo(res.data.message);
        } catch (err) {
          util.showError(err);
        } finally {
          this.isEdit = false;
          this.fetchData();
        }
      } else {
        let message = [];
        if (!formData.valid) {
          message.push(
            ...formData.errors
              .map((data) => {
                const uuid = data.id.split("_")[1];

                const index = this.dataTable.items.findIndex(
                  (item) => item.uuid && item.uuid === uuid,
                );

                if (index !== -1) {
                  if (data.id.startsWith("name_")) {
                    this.dataTable.items[index].name_touched = true;
                  }
                  if (data.id.startsWith("konversi_pln_")) {
                    this.dataTable.items[index].konversi_pln_touched = true;
                  }

                  message.push(
                    `Item ke-${index + 1}: ${data.errorMessages[0]}`,
                  );
                }

                return null;
              })
              .filter(Boolean),
          );
        }

        if (!itemsValid) {
          const itemRules = (item) => [
            () => (item.name ? true : "Nama harus diisi"),
            () => (item.konversi_pln ? true : "Konversi PLN tidak valid"),
            () =>
              typeof item.konversi_pln === "string" &&
              item.konversi_pln.trim().endsWith(",")
                ? "Konversi PLN tidak boleh diakhiri dengan koma"
                : true,
          ];

          const data = this.existing.items.filter((item) => !item.deleted);

          const validationResults = await Promise.all(
            data.flatMap((item, index) =>
              itemRules(item).map((rule) => {
                const result = rule();
                return result instanceof Promise
                  ? result.then((res) => ({ res, index }))
                  : { res: result, index };
              }),
            ),
          );

          const errors = validationResults.filter((v) => v.res !== true);

          if (errors.length > 0) {
            message.push(
              ...errors.map((err) => {
                return `Item ke-${err.index + 1}: ${err.res}`;
              }),
            );
          }
        }

        const getNumber = (str) => {
          const match = str.match(/Item ke-(\d+)/);
          return match ? parseInt(match[1]) : Infinity;
        };

        const uniqueMap = new Map();

        message.forEach((item) => {
          if (!uniqueMap.has(item)) {
            uniqueMap.set(item, item);
          }
        });

        message = Array.from(uniqueMap.values());

        message = message.sort((a, b) => getNumber(a) - getNumber(b));

        this.errorMessages = message;
        this.dialogValidation = true;
      }
    },
    cencelEdit() {
      let options = {
        page: this.existing.page,
        itemsPerPage: this.existing.perPage,
        sortBy: null,
      };

      this.isEdit = false;
      this.fetchData(options);
    },
    closeModal() {
      this.deleteId = null;
      this.dialogDelete = false;
      this.dialogValidation = false;

      this.errorMessages = [];
    },
    async deleteData() {
      let url = base_url + "/renewable-energy";

      try {
        const res = await axios.delete(url, {
          data: {
            id: this.deleteId,
          },
        });

        util.showInfo(res.data.message);
      } catch (err) {
        util.showError(err);
      } finally {
        this.closeModal();
        this.fetchData();
      }
    },
    handleInput(event, index) {
      let textField = event.target;
      if (!textField) return;

      let cursorPosition = textField.selectionStart;
      let formattedValue = formatNumber(textField.value);

      let lengthDiff = formattedValue.length - textField.value.length;
      let newCursorPosition = cursorPosition + lengthDiff;

      this.dataTable.items[index].konversi_pln = formattedValue;
      this.dataTable.items[index].is_touched = true;

      this.$nextTick(() => {
        textField.setSelectionRange(newCursorPosition, newCursorPosition);
      });
    },
  },
};
</script>

<style scoped>
:deep(thead) {
  background-color: #f0f1f4;
  font-weight: 500;
  font-size: 13px;
  color: #232323;
}

:deep(.v-table > .v-table__wrapper > table > tbody > tr > td),
:deep(.v-table > .v-table__wrapper > table > thead > tr > td),
:deep(.v-table > .v-table__wrapper > table > thead > tr > th) {
  padding: 0px 8px;
}
</style>
